module.exports = __webpack_public_path__ + "static/img/new_daily_cab_my2019_bannerinternal2.9aa0c59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/new_daily_cab_my2019_bannerinternal2.jpg
// module id = NtbT
// module chunks = 1